import {Component, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {ReplaySubject} from 'rxjs';
import {Model} from '../../../../../domain/model/common/model.class';
import {ActivatedRoute} from '@angular/router';
import {FormErrors} from '../../../../../components/forms/validation/form-validator.class';
import {StepScreenModel} from '../../../../shared/step/step-screen.component';
import {FileLocationFactory} from '../../../../../components/files/service/file-location.class';
import {ControlledSubstancePermitService} from '../../../../../domain/model/licenses-certifications/professional/permit/controlled-substance-permit.service';
import {PermitScreensManager} from './permit-screens-manager.service';
import {ControlledSubstancePermit} from '../../../../../domain/model/licenses-certifications/professional/permit/controlled-substance-permit.model';
import {ProfessionalLicenseService} from '../../../../../domain/model/licenses-certifications/professional/professional-license.service';
import {State} from '../../../../../domain/model/info/country/state.model';
import {CountryService} from '../../../../../domain/model/info/country/country.service';
import {VerificationService} from '../../../../../components/verification/service/verification.service';
import moment = require('moment');
import ProjectionInformation = Model.ProjectionInformation;

@Component({
    template: require('./permit-screen.component.html')
})
export class PermitScreenComponent {

    constructor(readonly modelService: ControlledSubstancePermitService,
                readonly professionalLicenseService: ProfessionalLicenseService,
                readonly route: ActivatedRoute,
                readonly screensManager: PermitScreensManager,
                readonly countryService: CountryService,
                readonly fileLocationFactory: FileLocationFactory,
                readonly verificationService: VerificationService) {

        countryService.getStates().subscribe(states => this.states = states);
    }

    // region Form
    readonly form$ = new ReplaySubject<NgForm>(1);

    @ViewChild(NgForm) set form(value: NgForm) {
        this.form$.next(value);
    }

    // endregion

    states$ = new ReplaySubject<Array<State>>(1);

    set states(value: Array<State>) {
        this.states$.next(value);
    }

    dateIssuedConstrains = {
        min: moment().subtract(100, 'year'),
        max: moment().add(5, 'year')
    };
    expirationDateConstrains = {
        min: moment().subtract(5, 'year'),
        max: moment().add(20, 'year'),
    };
    supportingDocumentFileLocation = this.fileLocationFactory.create('professionalLicense', `currentUser/${this.professionalLicenseIndex}/permit`, new ProjectionInformation('supportingDocument'));

    get professionalLicenseIndex(): number {
        return +this.route.snapshot.params['professionalLicenseIndex'];
    }

    stateName: string;

    stepScreenModel = new StepScreenModel<ControlledSubstancePermit>({
        initialDataModel: new ControlledSubstancePermit(),
        specificValidationMessages: {},
        screensManager: this.screensManager,
        _loadDataFn: () => {
            //TODO easier to use withLatestFrom, but it is not currently working (perhaps because of https://github.com/ReactiveX/rxjs/issues/2220)
            this.states$.first().flatMap(states => this.professionalLicenseService.getCurrentUserModelEntry(this.professionalLicenseIndex)
                .map(professionalLicense => ({professionalLicense: professionalLicense, states: states})))
                .map(({professionalLicense, states}) => states.find(s => s.code === professionalLicense!.state))
                .subscribe(state => this.stateName = state!.name);
            this.verificationService.setUrl('professionalLicense', undefined, `${this.professionalLicenseIndex}`, 'permit');
            return this.modelService.getCurrentUserModelEntry(this.professionalLicenseIndex);
        },
        _submitDataFn: (model: ControlledSubstancePermit) => {
            return this.modelService.updateCurrentUserModelEntry(this.professionalLicenseIndex, model);
        }
    });

    get model(): ControlledSubstancePermit {
        return this.stepScreenModel.dataModel;
    }

    get formErrors(): FormErrors {
        return this.stepScreenModel.formErrors;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/licenses-certifications/steps/professional/permit/permit-screen.component.ts